<template>
  <div v-if="isVisible">
    <dialog open>
      <p>
        {{ message }}
      </p>
      <button class="cancel" @click="close" v-if="cancelText">
        {{ appVocubulary[cancelText] }}
      </button>
      <button class="ok" @click="confirm">
        {{ appVocubulary[confirmText] }}
      </button>
    </dialog>
  </div>
</template>

<script>
export default {
  name: "WPopup",
  data() {
    return {
      isVisible: false,
      message: "",
      resolvePromise: undefined,
      rejectPromise: undefined,
    };
  },
  computed: {
    lang() {
      return this.$store.state.lang;
    },
    appVocubulary() {
      return this.$store.state.appVocubulary[this.lang].components.popup;
    },
  },
  methods: {
    show(options) {
      this.message = options.message;
      this.confirmText = options.confirmText;
      if (options.cancelText) {
        this.cancelText = options.cancelText;
      }

      this.isVisible = true;

      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve;
        this.rejectPromise = reject;
      });
    },
    confirm() {
      this.isVisible = false;
      this.resolvePromise(true);
    },
    close() {
      this.isVisible = false;
      this.resolvePromise(false);
    },
  },
};
</script>

<style lang="scss" scoped>
div {
  direction: ltr;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  // background-color: var(--tent-strong);
  z-index: 20;
  display: flex;
  justify-content: center;
  align-items: center;

  dialog {
    width: 90%;
    max-width: 500px;
    background-color: var(--bg2);
    border: none;
    border-radius: 10px;
    text-align: center;
    color: var(--text);
    box-shadow: 0 4px 8px 4px var(--tent-strong);

    p {
      width: 96%;
    }

    button {
      background-color: var(--accent);
      padding: 10px 20px;
      border-radius: 4px;
      margin: 10px;
      color: white;
    }
  }
}
</style>
